import {GetConfigsResult} from './types';

export const LOCAL_STORAGE_KEY = 'configs';

// Временно отключаем из-за бага https://st.yandex-team.ru/CALLFORMDEV-450
// export const LOCAL_STORAGE_TTL = 1000 * 60 * 15;
export const LOCAL_STORAGE_TTL = 1000;

export const DEFAULT_CONFIGS_RESULT: GetConfigsResult = {
    env: 'production',
    login: 'unknown',
    configs: {},
    appConfig: {},
    version: null,
};
